import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=2a135884&scoped=true&"
import script from "./curd.vue?vue&type=script&lang=js&"
export * from "./curd.vue?vue&type=script&lang=js&"
import style0 from "./curd.vue?vue&type=style&index=0&id=2a135884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a135884",
  null
  
)

export default component.exports